import * as React from "react";
import { Box, Paper } from "@mui/material";
import EventDetailsStrip from "./EventDetailsStrip";
import RegistrationForm from "./RegistrationForm";
import { cardSx, layout } from "./templateLayout";

/** Standard form surface: optional event details + registration form. */
export default function RegistrationFormCard({
  event,
  user,
  branding = {},
  primaryColor,
  onSubmit,
  submitting,
  showEventDetails = true,
  eventDetailsDense = false,
  embedded = false,
  sx = {},
}) {
  const content = (
    <>
      {showEventDetails && (
        <Box sx={{ mb: { xs: 2, sm: 3 } }}>
          <EventDetailsStrip
            event={event}
            branding={branding}
            primaryColor={primaryColor}
            dense={eventDetailsDense}
          />
        </Box>
      )}
      <RegistrationForm
        event={event}
        user={user}
        branding={branding}
        onSubmit={onSubmit}
        submitting={submitting}
        embedded={embedded}
      />
    </>
  );

  if (embedded) {
    return <Box sx={{ p: layout.cardPadding, ...sx }}>{content}</Box>;
  }

  return (
    <Paper elevation={0} sx={{ ...cardSx(branding), p: layout.cardPadding, ...sx }}>
      {content}
    </Paper>
  );
}
